import { ButtonRoundLg } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals'
import { ContactActionsModal } from '@apps-common/components/modals/contact-actions/ContactActionsModal'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  loading?: boolean
  entityId?: string
}

export const ContactActionsButton: React.FC<IProps> = ({ loading, entityId }) => (
  <ModalButton
    component={ContactActionsModal}
    disabled={loading}
    componentProps={{ entityId }}
    enterAnimation={modalSlideUpEnterAnimation}
    leaveAnimation={modalSlideUpLeaveAnimation}
    backdropDismiss
  >
    <ButtonRoundLg
      type='div'
      loading={loading}
      disabled={loading}
      className='action-success'
      tooltip={{ id: 'device-contact-actions', place: 'bottom', message: 'Contact actions' }}
    >
      <commonIcons.contactActions className='text-[1.1rem]' />
    </ButtonRoundLg>
  </ModalButton>
)
